import React, { useEffect, useState } from "react";
import { TextField, FormControl } from "@mui/material";

const BarcodeField = ({ barcode: defaultCode, disabled, error, onSave, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(defaultCode);

  const handleDetectedBarcode = async code => {
    setLoading(true);

    await onSave(code);

    setLoading(false);
  };

  useEffect(() => {
    if (code == defaultCode) return;
    const timeOutId = setTimeout(() => handleDetectedBarcode(code), 700);
    return () => clearTimeout(timeOutId);
  }, [code]);

  useEffect(() => {
    setCode(defaultCode);
  }, [defaultCode]);

  return (
    <FormControl fullWidth>
      <TextField
        {...props}
        error={!!error}
        helperText={error}
        placeholder="Barcode"
        label="BarcodeXXX"
        disabled={disabled || loading}
        value={code || ""}
        onChange={(e) => setCode(e.target.value)}
        variant="outlined"
      />
    </FormControl>
  );
};

export default BarcodeField;
